import { ACTIVE_OR_AUXILIARY_ONLY_ACTIVE_USERS } from '$lib/services/auth/policies';
import { REG_PATH_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = ACTIVE_OR_AUXILIARY_ONLY_ACTIVE_USERS;
export const policyExceptionHandler = REG_PATH_EXCEPTION_HANDLER;
